
import { createContext } from "react";

export const Animation = createContext({});